import React from "react";
import "./styles.scss";

function LoaderSpinner() {
  return <div className="loader" />;
}

export default LoaderSpinner;
